import { FileExpire } from './../_models/FileExpire';
import { HomeComponent } from 'src/app/Home/Home.component';
import { environment } from 'src/environments/environment';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../_services/authService/auth.service';
import { ToasterService } from '../_services/Toaster.service';


declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  model: any = {};
  LicenseFileFound = true;

  constructor(private router: Router, private authService: AuthService, private noti: ToasterService) { }

  ngOnInit() {
 this.CheckMac();
}




  login() {

    this.authService.login(this.model).subscribe(
      (next) => {
        this.noti.success('Login Success', 'Successfully Login');
        this.router.navigateByUrl('/Home');
      },
      (error) => {

        this.noti.error('Login Failed', 'User Not Found');
      }
    );
  }


  CheckMac() {
    try {
      this.authService.CheckMac().subscribe((Response) => {

        if(Response.status==200)
        {
          this.LicenseFileFound = true;
        }

      },
        err => {

          if (err.status == 404) {
            this.LicenseFileFound = false;
            this.router.navigateByUrl('/error');
          }

        });

    } catch (error) {
      if (error.status == 404) {
      }

    }

    this.sleep(2000);

  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
